import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  baseSkeleton: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  gridSkeletonMainDiv: {
    width: "100%",
    border: `1px solid ${colors.lightGrey}`,
    boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
    borderRadius: "12px",
    "& .react-loading-skeleton": {
      backgroundColor: colors.darkGrey,
      "--base-color": colors.darkGrey,
    },
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "2px 0px",
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  skeletonPaginationWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "90dvw",
      //Fallback for older browsers that don't support dvw
      "@supports not (width: 1dvw)": {
        width: "90vw"
      }
    },
  },
  skeletonPagination: {
    "& .react-loading-skeleton": {
      borderRadius: "20px",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        width: "40px !important",
      },
    },
  },
});

export default styles;
